import { ColorSchema, Color, COLOR_SCHEMA_LIGHT } from '../typings/design-tokens';

import { CSS_PREFIX } from './constants-es';
import { appendIfDoestStartWith } from './string-utils';

export interface IClassNames {
  [key: string]: any;
}

type ColorSchemaMapping = {
  [key in ColorSchema]?: Color;
};

export interface IColorMapping {
  colorSchemaMapping: ColorSchemaMapping;
  colorSchema?: ColorSchema;
  defaultColor?: Color;
}

const hasOwn = {}.hasOwnProperty;

/**
 * Wrapper around classname function
 * @param params classname params array of any
 */
function classNames(...params: Array<any>): string {
  const classes = [];
  for (const param of params) {
    const argType = typeof param;
    if (argType === 'string' || argType === 'number') {
      classes.push(param);
    } else if (Array.isArray(param)) {
      /* istanbul ignore else */ if (param.length) {
        const inner = classNames.apply(null, param);
        /* istanbul ignore else */ if (inner) {
          classes.push(inner);
        }
      }
    } else if (argType === 'object') {
      if (param.toString !== Object.prototype.toString) {
        classes.push(param.toString());
      } else {
        for (const key in param) {
          /* istanbul ignore else */ if (hasOwn.call(param, key) && param[key]) {
            classes.push(key);
          }
        }
      }
    }
  }

  return classes.join(' ');
}

const styles = (...args: any): string => {
  const classes = classNames(...args);
  const prefixed = classes
    .split(' ')
    .filter((cl: string) => cl.length > 0)
    .map(appendIfDoestStartWith(CSS_PREFIX))
    .join(' ');

  return prefixed;
};

export const makeClassNames = (classes: IClassNames): IClassNames =>
  Object.keys(classes).reduce((cn, key) => {
    cn[key] = styles(classes[key]);

    return cn;
  }, {});

export const applyColorSchema = (className: string, theme: ColorSchema): string => {
  if (theme === COLOR_SCHEMA_LIGHT) {
    return '';
  }

  return `${className}--${theme}`;
};

export const getMappedColor = ({ colorSchemaMapping, defaultColor, colorSchema }: IColorMapping): Color | undefined =>
  colorSchema ? colorSchemaMapping[colorSchema] : defaultColor;

export default styles;
